import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, makeStyles } from '@material-ui/core';

import Button from '../Button';

import './style.scss';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '100%'
    }
  },
  centerRelative: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      left: '41%'
    }
  }
}));

export default function WizardNavigation({
  back,
  next = true,
  showTerms,
  nextActionText,
  nextAction,
  showGoToAll
}) {
  const history = useHistory();
  const classes = useStyles();
  const { insuranceSelected } = useSelector(({ insurances }) => ({
    insuranceSelected: insurances.selected
  }));

  const { type: insuranceType } = insuranceSelected;

  return (
    <>
      <Box display='flex' mt='42px' className={classes.mainContainer}>
        <Button
          onClick={() => {
            back ? history.push(back) : history.goBack();
          }}
        >
          Volver
        </Button>

        {showGoToAll && (
          <Box width='189px' className={classes.centerRelative}>
            <Button
              theme='secondary'
              width='100%'
              onClick={() =>
                history.push(`${insuranceSelected.url}/planes/todos`)
              }
            >
              Ver todos los planes
            </Button>
          </Box>
        )}
        {next && (
          <Button color='secondary' onClick={() => nextAction()}>
            {nextActionText || 'Continuar'}
          </Button>
        )}
      </Box>
      {/* {showTerms && (
        <Box mt={2}>
          *Los importes informados NO incluyen las bonificaciones que
          eventualmente pudieran corresponder a promociones vigentes. Dichas
          bonificaciones serán efectuadas directamente por la Compañía
          Aseguradora y se verán reflejadas en su resumen de cuenta o tarjeta de
          crédito, de acuerdo a la modalidad de pago elegida.
        </Box>
      )} */}
    </>
  );
}
